<!--
 * @Author: ZechariahZheng
 * @Date: 2021-06-07 16:43:34
 * @LastEditors: 李款 lk313703.jx@chinatelecom.cn
 * @LastEditTime: 2024-07-06 11:30:26
 * @Description: 用户名下拉菜单
-->
<template>
    <span class="i-layout-header-trigger i-layout-header-trigger-min">
        <Dropdown :trigger="isMobile ? 'click' : 'hover'" class="i-layout-header-user"
            :class="{ 'i-layout-header-user-mobile': isMobile }" @on-click="handleClick">
            <Avatar size="small" :src="info.avatar" v-if="info.avatar" />
            <span class="i-layout-header-user-name" v-if="!isMobile">{{ info.name }}</span>
            <DropdownMenu slot="list">
                <i-link :to="'/dashboard/user/userInfo/' + info.id">
                    <DropdownItem>
                        <Icon type="ios-contact-outline" />
                        <span>{{ '个人中心' }}</span>
                    </DropdownItem>
                </i-link>
                <DropdownItem divided name="logout">
                    <Icon type="ios-log-out" />
                    <span>{{ '退出登录' }}</span>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    </span>
</template>
<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: 'iHeaderUser',
    computed: {
        ...mapState('admin/user', [
            'info'
        ]),
        ...mapState('admin/layout', [
            'isMobile',
            'logoutConfirm'
        ]),
      ...mapState('webphoneStrip', ['seatPost', 'refreshState']),
    },
    mounted() {
        // this.handleClick('logout');
        // console.log(this.info, 'infoinfoinfoinfo');
    },
    methods: {
        ...mapActions('admin/account', [
            'logout'
        ]),
        ...mapActions('admin/page', [
            'closeAll'
        ]),
        handleClick(name) {
            if (name === 'logout') {
                this.logout({}, {
                    confirm: this.logoutConfirm,
                    vm: this
                }).then(()=>{
                  //话务条自动签出(请放到最后，呼叫系统可能会报异常，导致后续代码无法执行)
                 /* if (this.refreshState.isCheck) {
                    this.$bus.$emit('controls', {type: 'checkOut',})
                  }*/
                });
            }
        },
        changeOrg(org) {
            this.abHttpUtil.postForm("/userResource/changeOrg?orgId=" + org.groupId, {}).then((data) => {
                location = location;
            })

        }
    }
}
</script>
